import * as Yup from 'yup';

const validationSchema = () =>
  Yup.object().shape({
    email: Yup.string().required('Email address is required').email('Invalid email address'),
  });

export default validationSchema;
